import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { useAppContext } from '~/contexts';
import { ShowToolbar } from './toolbar';

export interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { currentNetwork } = useAppContext();

  return (
    <>
      <ShowToolbar />
      <nav>
        <RouterTabs
          tabs={[
            {
              label: t('pages.shows.detail.tabs.design'),
              to: { pathname: '../design', search: location.search },
            },
            {
              label: t('common.labels.preview'),
              to: { pathname: '../preview', search: location.search },
            },
            {
              label: t('common.labels.settings'),
              to: { pathname: '../settings', search: location.search },
            },
            ...(currentNetwork.canManage.value
              ? [
                  {
                    label: t('common.tabs.audit_logs'),
                    to: { pathname: '../audit-logs', search: location.search },
                  },
                ]
              : []),
          ]}
          variant="scrollable"
        />
      </nav>
      <PageContainer>{children}</PageContainer>
    </>
  );
};
